'use client';

import { FC } from 'react';
import styles from './MessagesButton.module.css';
import { ButtonGroup } from '@/_components/ButtonGroup';
import { Button } from '@/_components/Button';
import { useRouter } from 'next/navigation';

export const MessagesButton: FC = () => {
  const { push } = useRouter();

  const onMessagesClick = () => push('/inbox');

  return (
    <div className={styles.messagesButton}>
      <ButtonGroup>
        <Button
          value="Messages"
          onClick={onMessagesClick}
          intent="secondary"
          size="small"
        />
      </ButtonGroup>
    </div>
  );
};
